export default "__VITE_ASSET__1KpwrUIi__"